import React, { useEffect, useState } from "react";
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import axios from "axios";
import { baseurl } from "../baseurl";
import {
  FiPackage,
  FiShoppingCart,
  FiAlertTriangle,
  FiDollarSign,
  FiCreditCard,
  FiSmartphone,
  FiTrendingUp,
} from "react-icons/fi";
import HomeInvoice from "./Invoice/HomeInvoice";

function Home() {
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch Analytics Report
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${baseurl}simpleAnalyticsReport`);
        if (res.data.success) {
          setAnalytics(res.data.data);
        }
      } catch (error) {
        console.error("Error fetching analytics:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <>
        <Topbar />
        <Sidebar />
        <main
          className="main-wrapper d-flex justify-content-center align-items-center"
          style={{ height: "100vh" }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </main>
      </>
    );
  }

  if (!analytics) {
    return (
      <>
        <Topbar />
        <Sidebar />
        <main className="main-wrapper text-center p-5">
          <h5 className="text-muted">No analytics data available.</h5>
        </main>
      </>
    );
  }

  return (
    <>
      <Topbar />
      <Sidebar />

      <main className="main-wrapper">
        <div className="main-content ms-3">
          <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
            <div className="breadcrumb-title pe-3">Dashboard</div>
          </div>

          {/* KPI Cards */}
          <div className="row g-4 mb-4">
            <div className="col-md-4">
              <div className="kpi-card bg-soft-primary d-flex align-items-center p-3 rounded shadow-sm">
                <div className="kpi-icon text-primary">
                  <FiPackage size={32} />
                </div>
                <div className="kpi-content ms-3">
                  <h6>Total Medicines</h6>
                  <h3>{analytics.total_medicines}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="kpi-card bg-soft-success d-flex align-items-center p-3 rounded shadow-sm">
                <div className="kpi-icon text-success">
                  <FiShoppingCart size={32} />
                </div>
                <div className="kpi-content ms-3">
                  <h6>Total Sold Medicines</h6>
                  <h3>{analytics.total_sold_medicines}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="kpi-card bg-soft-danger d-flex align-items-center p-3 rounded shadow-sm">
                <div className="kpi-icon text-danger">
                  <FiAlertTriangle size={32} />
                </div>
                <div className="kpi-content ms-3">
                  <h6>Expired Medicines</h6>
                  <h3>{analytics.expired_medicines}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="kpi-card bg-soft-warning d-flex align-items-center p-3 rounded shadow-sm">
                <div className="kpi-icon text-warning">
                  <FiDollarSign size={32} />
                </div>
                <div className="kpi-content ms-3">
                  <h6>Total Revenue</h6>
                  <h3>₹{analytics.total_revenue}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="kpi-card bg-soft-info d-flex align-items-center p-3 rounded shadow-sm">
                <div className="kpi-icon text-info">
                  <FiTrendingUp size={32} />
                </div>
                <div className="kpi-content ms-3">
                  <h6>Cash Revenue</h6>
                  <h3>₹{analytics.cash_revenue}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="kpi-card bg-soft-secondary d-flex align-items-center p-3 rounded shadow-sm">
                <div className="kpi-icon text-secondary">
                  <FiSmartphone size={32} />
                </div>
                <div className="kpi-content ms-3">
                  <h6>UPI Revenue</h6>
                  <h3>₹{analytics.upi_revenue}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="kpi-card bg-soft-dark d-flex align-items-center p-3 rounded shadow-sm">
                <div className="kpi-icon text-dark">
                  <FiCreditCard size={32} />
                </div>
                <div className="kpi-content ms-3">
                  <h6>Card Revenue</h6>
                  <h3>₹{analytics.card_revenue}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="kpi-card bg-soft-dark d-flex align-items-center p-3 rounded shadow-sm">
                <div className="kpi-icon text-dark">
                  <FiCreditCard size={32} />
                </div>
                <div className="kpi-content ms-3">
                  <h6>Total Stock Available </h6>
                  <h3>₹{analytics.total_stock_value}</h3>
                </div>
              </div>
            </div>

          </div>


          <HomeInvoice />
        </div>
      </main>
    </>
  );
}

export default Home;
